import { useCallback, useMemo } from 'react'
import { useAuthStore } from '@/stores/authStore'
import { hasAuthority } from '@/components/layout/nav'

/**
 * Permissões do usuário logado para gatear botões e ações (o menu já usa a
 * mesma regra via `isNavVisible`).
 *
 * ADMINISTRADOR passa por TIPO, sem depender de hierarquia — igual ao backend.
 * Os demais dependem das authorities da hierarquia. Quem não é do painel
 * (EMPRESA, parceiros) nunca recebe permissão administrativa por aqui: as telas
 * compartilhadas com a empresa dependem disso para esconder as ações internas.
 */
export function useAuthority() {
  const user = useAuthStore((s) => s.user)
  const userType = user?.type ?? ''

  const isAdmin = userType === 'ADMINISTRADOR'
  const isStaff = isAdmin || userType === 'COLABORADOR'

  const auths = useMemo<string[]>(() => {
    if (isAdmin) return ['*']
    return (user as { hierarchy?: { authorities?: string[] } } | null)?.hierarchy?.authorities ?? []
  }, [user, isAdmin])

  const can = useCallback(
    (needed: string) => isStaff && hasAuthority(auths, needed),
    [auths, isStaff],
  )

  return { can, isStaff, isAdmin }
}
